import React, { createContext, useState, useEffect } from "react";
import authStorage from "../../service/authStorage";

const ACCOUNT_URL = process.env.REACT_APP_ARI_URL + "/account";
const BEARER = authStorage();
const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const token = localStorage.getItem("token");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = () => {
      fetch(`${ACCOUNT_URL}`, {
        headers: {
          Authorization: BEARER,
        },
      })
        .then((response) => response.json())
        .then((result) => setUser(result))
        .catch((error) => console.log(error.message));
    };
    fetchUser();
  }, [token]);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export { UserContext, UserContextProvider };
